import { Link } from "react-router-dom";

interface VideoCardProps {
  id: number;
  title: string;
  thumbnail: string;
  duration: string;
  views: string;
  date: string;
  category: string;
  categoryName: string;
  size?: "normal" | "large";
}

export default function VideoCard({
  id,
  title,
  thumbnail,
  duration,
  views,
  date,
  category,
  categoryName,
  size = "normal",
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg mb-3 ${size === "large" ? "aspect-video" : "aspect-video"}`}>
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors duration-300"></div>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded font-label">
          {duration}
        </span>
        <span className="absolute top-2 left-2 px-2.5 py-0.5 bg-primary-500 text-white text-xs rounded-full font-label">
          {categoryName}
        </span>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug mb-1.5">
        {title}
      </h3>
      <div className="flex items-center gap-3 text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {views}
        </span>
        <span>{date}</span>
      </div>
    </Link>
  );
}